var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { Box } from "@chakra-ui/react";
import React from "react";
import { v4 } from "uuid";
import { WeatherDisplay } from "../PlayerPreview";
const AddPreviewCurrentWeather = (_a) => {
    var { onClick, widgetWidth } = _a, rest = __rest(_a, ["onClick", "widgetWidth"]);
    const weatherData = {
        type: "current",
        city: {
            label: "Toulouse, FR",
            lat: "43.6044622",
            lon: "1.4442469",
        },
        unit: "celcius",
        font: "Lobster",
        weight: "400",
        textColor: "#ffffff",
        backgroundColor: {
            type: "color",
            color: "#333333",
            gradient: {
                start: "#1C93FF",
                end: "#5CB9FF",
            },
        },
        theme: "default",
        weather: {
            city: {
                name: "Toulouse",
                country: "FR",
            },
            weather: {
                date: new Date(),
                description: "Ciel dégagé",
                icon: "01d",
                temp: 30,
                temp_max: 35,
                temp_min: 10,
            },
        },
    };
    const data = {
        id: v4(),
        data: weatherData,
    };
    const weather = {
        city: {
            name: "Toulouse",
            country: "FR",
        },
        weather: {
            date: new Date(),
            description: "Ciel dégagé",
            icon: "01d",
            temp: 30,
            temp_max: 35,
            temp_min: 10,
        },
    };
    return (React.createElement(Box, Object.assign({ onClick: () => onClick(data) }, rest),
        React.createElement(WeatherDisplay, { weatherData: weatherData, widgetWidth: widgetWidth !== null && widgetWidth !== void 0 ? widgetWidth : 0, weather: weather })));
};
const AddPreviewDailyWeather = (_a) => {
    var { onClick, widgetWidth } = _a, rest = __rest(_a, ["onClick", "widgetWidth"]);
    const incrementDay = (date, incrementBy) => {
        date.setDate(date.getDate() + incrementBy);
        return date;
    };
    const secondDay = new Date();
    const thirdDay = new Date();
    const fourthDay = new Date();
    const fifthDay = new Date();
    const weather = {
        city: {
            name: "Toulouse",
            country: "FR",
        },
        weather: [
            {
                date: new Date(),
                description: "Pluie légère",
                icon: "09n",
                temp: 30,
                temp_max: 17,
                temp_min: 9,
            },
            {
                date: incrementDay(secondDay, 1),
                description: "Éclair",
                icon: "11n",
                temp: 27,
                temp_max: 33,
                temp_min: 15,
            },
            {
                date: incrementDay(thirdDay, 2),
                description: "Ciel dégagé",
                icon: "01n",
                temp: 28,
                temp_max: 34,
                temp_min: 18,
            },
            {
                date: incrementDay(fourthDay, 3),
                description: "Couvert",
                icon: "03n",
                temp: 31,
                temp_max: 32,
                temp_min: 16,
            },
            {
                date: incrementDay(fifthDay, 4),
                description: "Couvert",
                icon: "03n",
                temp: 32,
                temp_max: 32,
                temp_min: 19,
            },
        ],
    };
    const weatherData = {
        type: "daily",
        city: {
            label: "Toulouse, FR",
            lat: "43.6044622",
            lon: "1.4442469",
        },
        unit: "celcius",
        font: "Lobster",
        weight: "400",
        textColor: "#ffffff",
        backgroundColor: {
            type: "color",
            color: "#333333",
            gradient: {
                start: "#1C93FF",
                end: "#5CB9FF",
            },
        },
        theme: "default",
        weather,
    };
    const data = {
        id: v4(),
        data: weatherData,
    };
    return (React.createElement(Box, Object.assign({ onClick: () => onClick(data) }, rest),
        React.createElement(WeatherDisplay, { weatherData: Object.assign(Object.assign({}, weatherData), { gridGap: 1 }), widgetWidth: widgetWidth !== null && widgetWidth !== void 0 ? widgetWidth : 0, weather: weather })));
};
const AddPreviewHourlyWeather = (_a) => {
    var { onClick, widgetWidth } = _a, rest = __rest(_a, ["onClick", "widgetWidth"]);
    const incrementHours = (date, incrementBy) => {
        date.setHours(date.getHours() + incrementBy);
        return date;
    };
    const secondDay = new Date();
    const thirdDay = new Date();
    const fourthDay = new Date();
    const fifthDay = new Date();
    const sixthDay = new Date();
    const weather = {
        city: {
            name: "Toulouse",
            country: "FR",
        },
        weather: [
            {
                date: new Date(),
                description: "Pluie légère",
                icon: "02d",
                temp: 30,
                temp_max: 17,
                temp_min: 9,
            },
            {
                date: incrementHours(secondDay, 3),
                description: "Éclair",
                icon: "11d",
                temp: 27,
                temp_max: 33,
                temp_min: 15,
            },
            {
                date: incrementHours(thirdDay, 6),
                description: "Ciel dégagé",
                icon: "01d",
                temp: 28,
                temp_max: 34,
                temp_min: 18,
            },
            {
                date: incrementHours(fourthDay, 9),
                description: "Couvert",
                icon: "03d",
                temp: 31,
                temp_max: 32,
                temp_min: 16,
            },
            {
                date: incrementHours(fifthDay, 12),
                description: "Couvert",
                icon: "03d",
                temp: 32,
                temp_max: 32,
                temp_min: 19,
            },
            {
                date: incrementHours(sixthDay, 15),
                description: "Neige",
                icon: "13d",
                temp: 32,
                temp_max: 32,
                temp_min: 19,
            },
        ],
    };
    const weatherData = {
        type: "hourly",
        city: {
            label: "Toulouse, FR",
            lat: "43.6044622",
            lon: "1.4442469",
        },
        unit: "celcius",
        font: "Lobster",
        weight: "400",
        textColor: "#ffffff",
        backgroundColor: {
            type: "color",
            color: "#333333",
            gradient: {
                start: "#1C93FF",
                end: "#5CB9FF",
            },
        },
        theme: "default",
        weather,
    };
    const data = {
        id: v4(),
        data: weatherData,
    };
    return (React.createElement(Box, Object.assign({ onClick: () => onClick(data) }, rest),
        React.createElement(WeatherDisplay, { weatherData: Object.assign(Object.assign({}, weatherData), { gridGap: 1 }), widgetWidth: widgetWidth !== null && widgetWidth !== void 0 ? widgetWidth : 0, weather: weather })));
};
export const AddPreview = [
    AddPreviewCurrentWeather,
    AddPreviewDailyWeather,
    AddPreviewHourlyWeather,
];
